/**
 *   V1.0
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 *
 * 维护中...
 *
 **/
import Lang from "@/components/Lang/Lang";
import dayjs from 'dayjs';
import {numberWithCommas} from './number-util';
import config from "@config/config";
import Locale from "@utils/locale";;
const localeLang = Locale.current();

/***
 * 去左右空格;
 */
function trim(str=''){
    if(str){
        str=str+'';
        return str.replace(/(^\s*)|(\s*$)/g,"");
    }return ''
}
/**
 * 是否为空
 * @param value
 * @returns {boolean}
 */
function isEmpty(value) {
    const type = Object.prototype.toString.call(value).slice(8, -1);
    switch(type) {
        case 'String':
            if(checkEmptyValue(value)) return true;
            return !trim(value);
        case 'Array':
            return !value.length;
        case 'Object':
            for(let t in value) return false;
            return true;
        case 'Number':
            if (isNaN(value)){
                return true;
            }else{
                return false;
            }
        case 'Undefined':
            return true;
        case 'Null':
            return true;
        default:
            return false; // 其他对象均视作非空
    }
}
function checkEmptyValue(value) {
    if(value == null || value == undefined || value==''||value =='null'||value =='Null'||value =='NULL'||value =='NaN'||value=='undefined'){
        return true;
    }else return false;
}

/***
 * 判断是否空对象
 */
function isEmptyObject(data) {
    if(data){
        const arr = Object.keys(data);
        return(arr.length == 0);//true
    }else return true;

}
// decimalPointFlag 是否补0
function formatNumberToPrice(num,separator=',',decimalPointFlag=false ) {
    num= num+'';
    let parts;
    parts = num.split('.');
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));
    if(decimalPointFlag&&isEmpty(parts[1])){
        parts[1] = '00';
    }else if (decimalPointFlag&&parts[1].length==1){
        parts[1] = parts[1]+'0'
    }
    return parts.join('.');
}
/**
 * 格式 数字
 * @param num 數字
 * @param separator 千位符
 * */
function splitNumber(num,separator=' ', splitNum=3) {
    num= num+'';
    let parts;
    parts = num.split('.');
    parts[0] = num.toString().replace(/(\d)(?=(\d{4})+(?!\d))/g, '$1' + (separator || ','));
    return parts.join('.');
}
/**
 * 格式 数字 俄语（欧美习惯）
 * @param num 數字
 * @param separator 千位符
 * */
function splitNumberRu(num=0) {
    num= num+'';
    return  num.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g,'$& ').replace('.',',');
}

// 保留两位小数 格式依然是数字
function toFixed2(number=0,decimalPlaces=2){
    // const iNum = Math.round(number * 100) / 100;
    // return iNum; 修改
    // const sNum = number.toFixed(2); // 统一 改为四舍五入，与后端一致
    // return isEmpty(sNum)?0:Number(sNum);
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(number * factor) / factor;
}
/**
 * 处理 货币 格式 纯文本
 * 服务湍 渲染建议传入 window以防sSymbol为空
 * */
function symbolMoneyUtil(price=0,ddpCurrencySymbol="") {
    if(typeof price=='number'){
        price = toFixed2(price)
    }else return price;
    return ((ddpCurrencySymbol=='₽'||ddpCurrencySymbol=='BYN'||ddpCurrencySymbol=='руб.')?`${splitNumberRu(price)} ${ddpCurrencySymbol}`:`${ddpCurrencySymbol} ${numberWithCommas(price)}`)
}
/**
 * 判断文件后缀
 * @param fileUrl 文件名
 * 回调后缀小写
 * */
function getFileSuffix(fileUrl){
    if(!isEmpty(fileUrl)){
        const index = fileUrl.lastIndexOf("\.");
        return fileUrl.substring(index + 1, fileUrl.length).toLowerCase();
    }else return ''
}
/*
    获取随机字符串 来源BPMS
    参数
    num ：Number 字符串长度
    */
function getRandomString(num){
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for( var i=0; i < num; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}
/* 获取 URL参数
    */
function getQueryString(name="id") {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    let context = "";
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}

/**
 * 请求
 * */
function postHttpAction(sUrl,data,callback){
    return $.ajax({
        url: sUrl,
        type:'post',
        dataType: "json",
        contentType: 'application/json',
        data:JSON.stringify(data),
        success:(res)=>{
            callback(res)
        },error: (err) => {
            callback(err);
        }
    });
}
/**
 * 请求
 * data 有需求可扩展成URL
 * */
function getHttpAction(sUrl,data,callback){
    return $.ajax({
        url: sUrl,
        type:'get',
        dataType: "json",
        contentType: 'application/json',
        success:(res)=>{
            callback(res)
        },error: (err={}) => {
            callback(err);
        }
    });
}

 function cloneObj(obj={}) {
    let newJsonObj = {};
        newJsonObj = JSON.parse(JSON.stringify(obj));
    for (let items in obj) {
        if (typeof obj[items] == "function" || typeof obj[items] == "undefined" || obj[items] instanceof RegExp) {
            newJsonObj[items] = obj[items];
        }
    }
    let newObj = new obj.constructor();
    for (let items in newJsonObj) {
        newObj[items] = newJsonObj[items]
    }
    return newObj;
}

/**
 * 限制输入多少个字节
 * value
 * maxBytes 最多允许的字节数
 */
function toCutByte(value='',maxBytes) {
    var byteLength = 0;
    var newValue = value;
    for (var i = 0; i < value.length; i++) {
        var charCode = value.charCodeAt(i);
        // 对于ASCII字符，字节长度为1，对于其他字符，通常为2到4
        byteLength += charCode < 128 ? 1 : 2;
        if (byteLength > maxBytes) {
            // 输入字节超出限制，截取字符串
            newValue = value.slice(0, i);
            break;
        }
    }
    return newValue;
}

/**
 * 以图搜图文件处理后上传，包括质量调整，大小调整
 * @param {文件Blob} file
 * @param {使用页面的this} _this
 */
function searchFileHandle(file,_this){
    if(!file instanceof Blob){
        console.error('传入的文件必须是Blob对象')
        return;
    }
    var reader = new FileReader();
    var fileSize = file.size;  //图片大小  fileSize / 1024 /1024
    var width,height
    _this.uploader.reset()
    reader.onload = function (e) {
        var img = new Image();
        img.onload = function() {
            // 图片加载完成后，获取其宽高
            console.log('Image width:', img.width);  //单位像素
            console.log('Image height:', img.height);
            // searchFileHandle(img,uploader)
            width = img.width;
            height = img.height;

            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            // 设置canvas的尺寸，这里我们将其设置为原图的一半
            //当宽高大于4000 时，设置为3000，图片等比压缩 ，当宽高小于100 时设置为100，当质量大小为4M-10M时，设置图片质量为0.8
            if(width>4000 || height > 4000 || width <100 || height<100 || (fileSize < 10*1024*1024 && fileSize > 4*1024*1024)){
                if((width>4000 || height>4000)){ //当宽高都大于4000 或者只有宽大于4000时 。设置宽为3000 ，高等比例缩放
                    if(width > height){ //宽高谁大，谁用来取比例，缩小到3000，这样另一个边的尺寸肯定也会小于3000
                        canvas.width = 3000;
                        var translate = 1- ((width-3000) / width)  // 获取当前比例
                        canvas.height = height * translate;
                    }else{
                        canvas.height = 3000;
                        var translate = 1- ((height-3000) / height)  // 获取当前比例
                        canvas.width = width * translate;
                    }

                }else if((height < 100 || width < 100)){ //当宽高小于100 或者 宽小于100
                    if(width<height){ //宽高谁小，谁用来取比例，放大到100，这样另一个边的尺寸肯定也会大于100
                        canvas.width = 100;
                        var translate = 1- ((width-100) / width)  // 获取当前比例
                        canvas.height = height * translate;
                    }else{
                        canvas.height = 100;
                        var translate = 1- ((height-100) / height)  // 获取当前比例
                        canvas.width = width * translate;
                    }

                }else{  //图片尺寸在宽高都在 4000-100 中间时
                    canvas.width = width;
                    canvas.height = height;
                }

                // 将图片绘制到canvas上
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                // 当图片的大小在 4 - 10M时，质量压缩到80%
                if((fileSize < 10*1024*1024 && fileSize > 4*1024*1024)){
                    // 将canvas转换为DataURL，并设置质量为0.8
                    var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                }else if(fileSize < 4*1024*1024){  //当图片大小小于4M时，按原尺寸质量
                    // 将canvas转换为DataURL，并设置质量为0.8
                    var dataUrl = canvas.toDataURL('image/jpeg', 1);
                }

                // dataUrl 得到一个base64 的 图片
                // 将base64 转为blob文件
                var binaryString = window.atob(dataUrl.split(',')[1]);
                var len = binaryString.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                // return bytes.buffer;
                var mimeType = 'image/jpeg'; // 或者根据实际的MIME类型来设置
                var blob = new Blob([bytes.buffer], { type: mimeType });
                // blob 转为 blob 后 此内容为 file
                _this.uploader.addFile(blob);
                if(_this.loading){
                    _this.loading(true)
                }

            }else{ //当前图片是正常的图片时，直接上传
                _this.uploader.addFile(file);
                if(_this.loading){
                    _this.loading(true)
                }
            }

        }
        img.src = e.target.result;
    }
    reader.readAsDataURL(file);
}

function getWeek(timesTamp){
    const weekArr =[
        Lang({id:"XingQiRi",default:"星期日"}),
        Lang({id:"XingQiYi",default:"星期一"}),
        Lang({id:"XingQiEr",default:"星期二"}),
        Lang({id:"XingQiSan",default:"星期三"}),
        Lang({id:"XingQiSi",default:"星期四"}),
        Lang({id:"XingQiWu",default:"星期五"}),
        Lang({id:"XingQiLiu",default:"星期六"}),
    ];
    const dateCur = new Date(parseInt(timesTamp));
    return weekArr[dateCur.getDay()];
}
function getIntlYYMMDD(timesTamp,sFormat){
    if(!timesTamp) return;
    return localeLang=="zh"?dayjs(timesTamp).format("YYYY-MM-DD"+(sFormat?" "+sFormat:"")):dayjs(timesTamp).format("DD.MM.YYYY"+(sFormat?" "+sFormat:""));

}
/*
* @param attr 排序的属性 如number属性
* @param rev true表示升序排列，false降序排序
* */
function sortBy(attr,rev){
    //第二个参数没有传递 默认升序排列
    if(rev ==  undefined){
        rev = 1;
    }else{
        rev = (rev) ? 1 : -1;
    }

    return function(a,b){
        a = a[attr];
        b = b[attr];
        if(a < b){
            return rev * -1;
        }
        if(a > b){
            return rev * 1;
        }
        return 0;
    }
}

function filter(str) { // 特殊字符转义
    str += ''; // 隐式转换
    str = str.replace(/%/g, '%25');
    str = str.replace(/\+/g, '%2B');
    str = str.replace(/ /g, '%20');
    str = str.replace(/\//g, '%2F');
    str = str.replace(/\?/g, '%3F');
    str = str.replace(/&/g, '%26');
    str = str.replace(/\=/g, '%3D');
    str = str.replace(/#/g, '%23');
    return str;
}
/**
 * 将对象转换为url参数
 * @param {paramObj}
 * return string
 */
function formateObjToParamStr(paramObj) {
    const sdata = [];
    for (let attr in paramObj) {
        if(!isEmpty(paramObj[attr]))sdata.push(`${attr}=${filter(paramObj[attr])}`);
    }
    return sdata.join('&');
}

/**
 * 获取需要预处理报表的url
 * @param baseHandlerURL, String，预处理的url, 可包含path参数
 * @param handlerParams， Object，传给预处理控制器的必要参数
 * @param resourceParams，Object 报表资源，参考上一个函数
 * @param renderParams， Object 渲染报表必要参数，参考上一个函数
 *
 *  exportApi // 特别注意：每个环境要配置不同的report.domain（访问对应环境的报表）
 *
 * @returns {string}
 */
function getHandlerURL(baseHandlerURL, handlerParams, resourceParams, renderParams) {
    const resParams = resourceParams ? {
            template: resourceParams.resid,         //资源id
            langCode: resourceParams.langCode || 'en',               //站点语言
            buyerId:  resourceParams.buyerId || '',         //采购商id,如果为空，则为系统模板
            currencyCode: resourceParams.currencyCode,  //币种
            isCheck:0       //后端要求加上了。。。
        } : {},
        //混淆参数
        smokeParams = {
            timestamp: new Date() * 1,
            token: getRandomString(16),
            pwd: getRandomString(8)
        },
        params = {...resParams, ...renderParams, ...smokeParams, ...handlerParams} //$.extend({}, resParams, renderParams, smokeParams, handlerParams);
    return config.servers[config.environment].exportApi + baseHandlerURL + "?" + formateObjToParamStr(params);
}
//工具类
export default {
    getHandlerURL,
    formateObjToParamStr,
    cloneObj,
    sortBy,
    trim,
    isEmpty,
    isEmptyObject,
    formatNumberToPrice,
    splitNumber,
    splitNumberRu,
    toFixed2,
    getFileSuffix,
    getRandomString,
    symbolMoneyUtil,
    getQueryString,
    postHttpAction,
    getHttpAction,
    toCutByte,
    searchFileHandle,
    getWeek,
    getIntlYYMMDD
};
export {
    getHandlerURL,
    formateObjToParamStr,cloneObj,sortBy, trim, isEmpty, isEmptyObject, formatNumberToPrice, splitNumber,toFixed2,getFileSuffix,getRandomString,splitNumberRu,symbolMoneyUtil,getQueryString,postHttpAction,getHttpAction,toCutByte,searchFileHandle,getWeek,getIntlYYMMDD };
